<template>
  <div class="future-coaching-item futcchnbox">
    <slot />

    <div class="futcchnbox_avatar_container">
      <img
        v-if="getImage(l_item)"
        class="futcchnbox_avatar"
        :src="getImage(l_item)"
      />
    </div>

    <div
      class="futcchnbox_name"
      :title="l_item.coach_name"
    >
      <div class="futcchnbox_name_text">
        {{ l_item.name }}
      </div>
      <div class="futcchnbox_tags">
        <div
          class="futcchnbox_tag"
          :style="`--clr-tag:var(--clr-${l_item.format})`"
        >
          {{
            l_item.format === 'theory'
              ? $t(`common.theory`)
              : $t(`gametypes.groups.${l_item.format}`)
          }}
        </div>
        <div
          class="futcchnbox_coach clr-grey my-auto truncate"
          :title="$t(`coaches.${l_item.coach_id}.name_nick`)"
        >
          {{ $t(`coaches.${l_item.coach_id}.nick`) }}
        </div>
        <div
          v-if="hasTitleDate"
          class="futcchnbox_date clr-grey my-auto truncate"
        >
          {{ formattedTime }}
        </div>
      </div>
    </div>
    <div
      v-if="hasBtn"
      class="futcchnbox_btn"
    >
      <div
        v-if="!l_item.in_progress"
        class="futcchnbox_btn_time futcchnbox_btn_item"
        :title="formattedTimeLong"
      >
        {{ formattedTime }}
      </div>

      <div v-else-if="!l_item.available_to_user">
        <v-btn
          color="primary"
          class="mb-1 futcchnbox_btn_item text-wrap"
          @click="$router.push({ name: 'Subscription' })"
        >
          <i class="mdi mdi-crown mr-2 text-semi-large text-center"></i>
          {{ $t('btn.upgrade_join') }}
        </v-btn>
        <div
          class="text-small text-center clr-grey uppercase"
          :title="formattedTimeLong"
        >
          {{ formattedTime }}
        </div>
      </div>

      <div v-else-if="l_item.in_progress">
        <v-btn
          color="primary"
          :target="'_blank'"
          :href="l_item.live_link"
          class="mb-1 futcchnbox_btn_item text-wrap text-center"
        >
          {{ $t('btn.join_coaching') }}
        </v-btn>
        <div
          class="text-small text-center clr-grey uppercase"
          :title="formattedTimeLong"
        >
          {{ formattedTime }}
        </div>
      </div>

      <div
        v-if="!l_item.in_progress && hasBtnSubText"
        class="mt-2 f-column"
      >
        <router-link
          v-if="!l_item.available_to_user"
          :to="{
            name: 'SubscriptionOverview',
          }"
          class="text-medium f-center gw_btn gw_btn_primary gw_btn_text"
          style="--clr: var(--clr-primary); --clr-back: rgba(0, 172, 141, 0.125); --width: 100%"
        >
          <div class="mdi mdi-crown mr-1"></div>
          {{ $t('messages.only_for_premium') }}
        </router-link>
        <div
          v-else
          class="clr-grey text-medium text-center mt-1"
        >
          {{ $t(`coachings.link_message_before_start`) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import { allCoaches, getMappedCoachingItem } from '@/helpers/coachings'

export default {
  name: 'VideoList',
  mixins: [format_mix],
  props: {
    item: { default: () => {} },
    hasBtnSubText: { type: Boolean, default: true },
    hasBtn: { type: Boolean, default: true },
    hasTitleDate: Boolean,
  },
  data() {
    this.timezone = new Date()
      .toLocaleDateString('de-DE', { day: '2-digit', timeZoneName: 'short' })
      .slice(4)
    return {
      interval: null,
      l_item: null,
    }
  },
  created() {
    this.l_item = getMappedCoachingItem({ item: this.item.item })
    this.interval = setInterval(() => {
      this.l_item = getMappedCoachingItem({ item: this.item.item })
    }, 5000)
  },
  beforeUnmount() {
    clearInterval(this.interval)
  },
  methods: {
    getImage(item) {
      const img = allCoaches().find(i => i.id === item?.coach_id)?.img
      return img && new URL(`/src/assets/coaches/${img}`, import.meta.url).href
    },
  },
  computed: {
    l_items() {
      const res = this.items
      return res
    },
    datetime() {
      const res = this.formatISODate(this.item.datetime_cest, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: true,
        minute: true,
      })
      return res
    },
    formattedTime() {
      const res = `${this.datetime}`
      return res
    },
    formattedTimeLong() {
      const res = `${this.datetime}`
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.futcchnbox {
  --clr-back: var(--clr-black-1);
  --clr-back-hover: var(--clr-black-1-2);

  --padding: 2rem;
  --gap: 1.5rem;
  --avatar-size: 6rem;
  --name-size: 1.25rem;
  --tag-size: 0.8rem;
  --coach-size: 0.875rem;
  --name-line-clamp: 2;
  --btn-flex: 0;
  --title-date-size: 0.875rem;

  display: flex;
  position: relative;
  align-items: center;
  border-radius: 8px;
  width: 100%;
  transition: 0.22s;

  gap: var(--gap);
  padding: var(--padding);
  background: var(--clr-back);
  color: var(--clr-white-0);
  &_avatar {
    &_container {
      background: var(--clr-black-2);
      height: var(--avatar-size);
      width: var(--avatar-size);
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      transition: inherit;
      border: solid 4px var(--clr-black);
      z-index: 1;
      position: relative;
      overflow: hidden;
    }
    border-radius: 50%;
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
  &_name {
    display: flex;
    flex-direction: column;
    font-weight: 500;
    font-size: var(--name-size);
    min-width: 8rem;
    flex: 1;
    z-index: 1;
    position: relative;

    &_text {
      overflow: hidden;
      display: -webkit-box !important;
      -webkit-line-clamp: var(--name-line-clamp);
      -webkit-box-orient: vertical;
      white-space: normal;
      line-height: 1.4;
    }
  }
  &_theme {
    width: 16rem;
    font-weight: 700;
    font-size: 1.25rem;
  }
  &_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    flex: var(--btn-flex);
    align-items: center;
    justify-content: center;
    z-index: 1;
    position: relative;

    &_time {
      background: var(--clr-black-0);
      border-radius: 4px;
      padding: 0.5rem 1rem;
      text-transform: uppercase;
      align-items: center;
      justify-content: center;
      display: flex;
    }
    &_item {
      min-width: 14rem;
      height: unset;
      white-space: nowrap;
    }
  }
  &_tags {
    display: flex;
    flex-wrap: wrap;
  }
  &_tag {
    border-radius: 4px;
    background: var(--clr-black-2);
    font-size: var(--tag-size);
    color: var(--clr-white-0);
    padding: 0 0.25rem;
    margin: 0.25rem 0.25rem 0.25rem 0;
    text-transform: uppercase;
    position: relative;
    overflow: hidden;
    padding: 0 0.25rem 0 0.75rem;
    --clr-tag: red;
    &:before {
      content: '';
      height: 100%;
      width: 6px;
      position: absolute;
      background: var(--clr-tag);
      left: 0;
      top: 0;
    }
  }
  &_coach {
    font-size: var(--coach-size);
    padding-right: 0.25rem;
  }
  &_date {
    font-size: var(--title-date-size);
    line-height: 1.4;
  }
}

@media (max-width: 1023px) {
  .futcchnbox {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    &_btn {
      &_item {
        max-width: unset;
      }
    }
  }
}
</style>
